import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Users, Check, X, Map, MapPin } from 'lucide-react';
import { getAdminUsers, getAdminSystems } from '../api';

function UsersSection() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAdminUsers()
      .then(res => setUsers(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading loading--sm"><div className="spinner" /></div>;

  return (
    <>
      <div className="section-header">
        <h2 className="section-header__title">
          <Users size={20} style={{ verticalAlign: 'middle', marginRight: 8 }} />
          USERS
        </h2>
        <span className="section-header__meta">{users.length} total</span>
      </div>
      <div className="grid grid--gap-md mb-xl">
        {users.map(user => (
          <div key={user.id} className="card admin-user">
            <div className="admin-user__row">
              <div className="admin-user__info">
                <div className="admin-user__name">
                  {user.firstName} {user.lastName}
                  {user.username && <span className="admin-user__username">@{user.username}</span>}
                  {user.isAdmin && <span className="badge badge--green">ADMIN</span>}
                </div>
                <div className="admin-user__email">{user.email}</div>
              </div>
              <div className="admin-user__meta">
                <span className="admin-user__stat">{user.systemCount} systems</span>
                <span className="admin-user__stat">
                  {user.stravaConnected
                    ? <><Check size={14} color="var(--accent)" /> Strava</>
                    : <><X size={14} color="var(--text-muted)" /> Strava</>
                  }
                </span>
                <span className="admin-user__stat">
                  Joined {new Date(user.createdAt).toLocaleDateString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

function SystemsSection() {
  const [systems, setSystems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAdminSystems()
      .then(res => setSystems(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading loading--sm"><div className="spinner" /></div>;

  return (
    <>
      <div className="section-header">
        <h2 className="section-header__title">
          <Map size={20} style={{ verticalAlign: 'middle', marginRight: 8 }} />
          TRAIL SYSTEMS
        </h2>
        <span className="section-header__meta">{systems.length} total</span>
      </div>
      <div className="grid grid--gap-md">
        {systems.map(system => (
          <Link key={system._id} to={`/admin/trails/${system._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="card system-card system-card--link">
              <div className="flex-1">
                <div className="system-card__name">{system.name}</div>
                <div className="system-card__meta">
                  {system.region}{system.country ? `, ${system.country}` : ''}
                  {' · '}{system.trailCount} trails
                  {' · '}{system.userCount} {system.userCount === 1 ? 'rider' : 'riders'}
                </div>
                {system.trailsWithCoords < system.trailCount && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '6px', fontSize: '12px', color: 'var(--warning-border)' }}>
                    <MapPin size={12} />
                    {system.trailCount - system.trailsWithCoords} trails missing coordinates
                  </div>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}

export default function Admin() {
  return (
    <div>
      <div className="page-header page-header--lg">
        <div className="page-header__row">
          <div>
            <h1 className="page-header__title">ADMIN</h1>
            <p className="page-header__subtitle">Manage trails, users, and data</p>
          </div>
        </div>
      </div>

      <UsersSection />
      <SystemsSection />
    </div>
  );
}
